import React from "react";
import PageShell from "../PageShell";
import Loadable from 'react-loadable'
import Loading from '../../Loading'

const LoadablePrivacyPolicy = Loadable({
  loader: () => import('./PrivacyPolicy'),
  loading: Loading,
});

const PrivacyPage = () => (
  <PageShell
    title="Your Privacy Matters"
    blurb="Below is our privacy policy"
    img={require("assets/img/privacy-bg.jpg")}
    components={[<LoadablePrivacyPolicy key={0} />]}
  />
);

export default PrivacyPage;



// WEBPACK FOOTER //
// ./src/views/PrivacyPage/PrivacyPage.jsx